import { Record as record } from 'immutable';

import { construct, fields } from '../../helpers/LinkMapper';
import { daySaveTypes } from '../TicketType';

const defaults = {
    code: 0,
    name: "",
    fee: 0,
    moreDetailsRequired: false,
    automated: false,
    itso: false,
    isEticket: false,
    isSeasonTicket: false,
    isHidden: false
};

class RefundReason extends record(defaults) {

    availableOnline () {
        return this.automated;
    }

    isApplicable (ticketCode) {
        if (daySaveTypes.includes(ticketCode) && this.code !== 3) { return false; }

        return true;
    }

    static fromJSON (json) {
        return construct(RefundReason, json, {
            code: fields.number,
            name: fields.string,
            fee: fields.number,
            moreDetailsRequired: fields.bool,
            automated: fields.bool,
            itso: fields.bool,
            isEticket: fields.bool,
            isSeasonTicket: fields.bool,
            isHidden: fields.bool
        });
    }
}

export default RefundReason;



// WEBPACK FOOTER //
// ./src/records/refund/Reason.js